import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Duanxin"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M16.4585 11.8558L22.4906 16.7403V6.97132L16.4585 11.8558ZM14.0591 13.7988C13.4651 14.2799 12.7367 14.5204 12.0083 14.5204C11.2799 14.5204 10.5516 14.2799 9.95725 13.7987L8.69683 12.7778L1.54326 18.5715C1.61228 19.092 1.86742 19.5541 2.24053 19.8885C2.41846 20.048 2.62352 20.1773 2.84681 20.2713C3.10101 20.3783 3.37912 20.4392 3.67197 20.4392H20.3413C20.712 20.4392 21.0592 20.3422 21.3635 20.1757C21.5773 20.0588 21.7705 19.9086 21.9329 19.7291C22.2193 19.4126 22.4122 19.0113 22.4703 18.5677L15.3201 12.7777L14.0591 13.7988ZM1.52271 6.96729V16.7444L7.55854 11.8559L1.52271 6.96729Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.83526 11.856L10.8592 12.6853C11.525 13.2245 12.4917 13.2245 13.1575 12.6853L14.1817 11.8559L15.3202 10.9341L22.4306 5.1763C22.2058 4.22992 21.3555 3.52295 20.3414 3.52295H3.67209C2.65915 3.52295 1.80975 4.22825 1.58374 5.17295L8.69695 10.9341L9.83526 11.856Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var duanxin = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { duanxin as default };
